import { component } from 'picoapp';
import Parallax from 'parallax-js';
import { Linear, gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default component(async (node) => {
  gsap.registerPlugin(ScrollTrigger);

  const { event } = node.dataset;

  const initMouseParallax = () => {
    const container = node.querySelector('[data-container]');

    // eslint-disable-next-line no-new
    new Parallax(container ?? node, {
      selector: '[data-parallax]'
    });
  }

  const getFactoredValue = (value) => {
    const breakpoint = window.matchMedia('(min-width: 768px)');

    if (breakpoint.matches) {
      return value * 5;
    }

    return value;
  }

  const initScrollParallax = () => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: node,
        scrub: true,
        start: 'top bottom',
        // end: 'bottom top',
        end: `+=${getFactoredValue(window.innerHeight)}`,
      },
    });

    const items = node.querySelectorAll<HTMLElement>('[data-parallax]');

    gsap.utils.toArray(items).forEach((item: HTMLElement) => {
      const depth = Number(item.dataset.depth);
      const movement = -(getFactoredValue(item.offsetHeight * depth))

      timeline.to(item, { y: movement, ease: Linear.easeInOut }, 0);
    });
  };

  if (event === 'scroll') {
    initScrollParallax();
  } else {
    initMouseParallax();
  }
});
